import React, { useState } from "react";
import { Button, FormLabel, Stack, TextField } from "@mui/material";
import User from "../../types/User";
import { LessonState } from "../../types/Lessons";

import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import CheckIcon from '@mui/icons-material/Check';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { LoadingButton } from "@mui/lab";
import Toolbox from "../Shared/Toolbox";
import { ChangeProps } from "./Solution";

export type ActionProps = {
  user: User;
  isUpdating: boolean;
  onReview: () => void;
  onAccept: () => void;
  onReject: (comment?: string) => void;
  onReopen: () => void;
}

const Actions = (props: ActionProps & ChangeProps) => {

  const OwnerActions = () => {
    return <>
      <LoadingButton loading={props.isUpdating} variant="outlined" color="primary" size="small" disabled={typeof(props.lesson?.approver) === "undefined" || !props.lesson?.mitigation} onClick={props.onReview} startIcon={<BookmarkAddedIcon />}>Send to review</LoadingButton>
      </>
  }

  const ApproverActions = () => {
    const [reject, shouldReject] = useState<boolean>(false);
    const [rejectComment, setRejectComment] = useState<string>();

    return <>
      <LoadingButton loading={props.isUpdating} variant="outlined" color="error" size="small" onClick={() => shouldReject(true)} startIcon={<DoDisturbIcon />}>Reject</LoadingButton>
      <LoadingButton loading={props.isUpdating} variant="outlined" color="primary" size="small" onClick={props.onAccept} startIcon={<CheckIcon />}>Approve</LoadingButton>

      { reject && <Toolbox title="Reject review" maxWidth="sm" onClose={() => shouldReject(false)}>
        <FormLabel>Do you want to add a reason?</FormLabel>
        <TextField variant="filled" multiline rows={3} placeholder="Reason" value={rejectComment} onChange={e => setRejectComment(e.currentTarget.value)} />
        <Button variant="outlined" color="secondary" onClick={() => props.onReject(rejectComment)}>Confirm</Button>
      </Toolbox> }
    </>
  }

  const DoneActions = () => {
    return <>
      <LoadingButton loading={props.isUpdating} variant="text" color="primary" size="small" onClick={props.onReopen}>Reopen for edit</LoadingButton>
    </>
  }

  const renderContent = () => {
    switch (LessonState[props.lesson.state]) {
      case LessonState.approved:
        if (props.lesson?.approver?.id === props.user.id) {
          return <DoneActions />
        } break;
      case LessonState.rejected:
        return <DoneActions />
      case LessonState.review:
        if (props.lesson?.approver?.id === props.user.id) {
          return <ApproverActions />
        } break;
      default:
        return <OwnerActions />;
    }
  }

  return <Stack direction="row" spacing={1} justifyContent="center">{renderContent()}</Stack>
}

export default Actions;